<script setup lang="ts">
import { onMounted } from 'vue';
import {
  useRoute,
  useRouter,
} from 'vue-router';

import VLoader from '@components/loader/VLoader.vue';
import { REGISTRATION_ROUTE_NAME } from '@modules/registration/constants';
import { useRegisterAffiliateReferralMutation } from '@modules/registration/mutations';
import { isString } from '@utils/guards';

const route = useRoute();
const router = useRouter();
const { mutateAsync } = useRegisterAffiliateReferralMutation();

onMounted(async () => {
  if (isString(route.params.token)) {
    try {
      await mutateAsync({
        token: route.params.token,
      });
    } catch (error) {
      console.error('Failed to fetch affiliate token', error);
    }
  }

  void router.replace({
    name: REGISTRATION_ROUTE_NAME,
  });
});
</script>

<template>
  <VLoader v-data-qa-auto-id="'RegistrationAffiliateReferralPage'"
    loading
  />
</template>
